<template>
    <div>
        <div v-if="mode === ''">

        </div>
        <b-table class="mt-5"
                 striped
                 bordered
                 outlined
                 table-variant="light"
                 responsive='true'
                 head-variant="dark"
                 :fields="fields"
                 sort-by="department"
                 :filter="mode"
                 :filter-ignored-fields="ignored"
                 :items="items">

            <template #cell(service)="data">
               <b><span v-html=data.item.service></span></b>
            </template>
            <template #cell(type)="data">
                <b-button :href="data.item.url" target="_blank" variant="info" size="sm">Book an {{data.item.type}} Appointment</b-button>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: "contenttable",
        props:['mode','items'],
        data(){
            return{
                itemstmp:[
                    {Department:'Library',Service:'Library Research Appointments',Link:'Research Appointments<br>Get one-on-one research help from a librarian.',url:'https://crc-losrios.libcal.com/appointments',Type:'Online'},
                    {Department:'Library',Service:'Student Tech Support',Link:'Student Tech Help<br>Assistance with technology & tools to help you be successful.',url:'https://crc.losrios.edu/student-resources/library/student-tech-help',Type:'Online'},
                    {Department:'Library',Service:'Book a Study Room',Link:'Book a Study Room<br>Collaborative workspace for groups of two or more.',url:'https://crc-losrios.libcal.com/reserve/groupstudyrooms',Type:'On-Ground'},
                    {Department:'Library',Service:'Computer Use',Link:'Computer Use<br>Use a computer in the library for school work and personal matters.',url:'https://researchguides.crc.losrios.edu/c.php?g=1179734',Type:'On-Ground'},
                    {Department:'Library',Service:'Student Tech Support',Link:'Student Tech Help<br>Assistance with technology & tools to help you be successful.',url:'https://researchguides.crc.losrios.edu/c.php?g=1179734',Type:'On-Ground'},
                    {Department:'Library',Service:'Borrow a book or technology',Link:'Borrow a Book or Technology<br>Check out a book or a computer so you can work on your assignments.',url:'https://researchguides.crc.losrios.edu/c.php?g=1179734',Type:'On-Ground'},
                    {Department:'Library',Service:'Copy and Print ',Link:'Copy & Print<br>Make FREE prints and copies in the Library.',url:'https://researchguides.crc.losrios.edu/c.php?g=1179734',Type:'On-Ground'},
                    {Department:'Library',Service:'Study Space Use',Link:'Study Space Use<br>Study in the individual quiet  areas for your classes.',url:'https://researchguides.crc.losrios.edu/c.php?g=1179734',Type:'On-Ground'},
                    {Department:'Math Center',Service:'Computer Use/Study Space',Link:'Computer Use or Study Space Reservation.',url:'https://researchguides.crc.losrios.edu/c.php?g=1183451',Type:'On-Ground'},
                    {Department:'RWC',Service:'Computer Use/Study Space',Link:'Computer Use or Study Space Reservation.',url:'https://researchguides.crc.losrios.edu/c.php?g=1183399',Type:'On-Ground'},
                    {Department:'Counseling & Student Services',Service:'Counseling Appointment',Link:'Make a counseling appointment.',url:'http://esars.crc.losrios.edu/eSARS/CollegeCenter_SS/eSARS.asp',Type:'On-Ground'},
                    {Department:'Admissions and Records',Service:'Admissions & Records Appointment',Link:'Make an appointment with Admissions and Records.',url:'http://esars.crc.losrios.edu/eSARS/CollegeCenter_AR/eSARS.asp',Type:'On-Ground'},
                    {Department:'Financial Aid',Service:'Financial Aid Appointment',Link:'Make an appointment with Financial Aid.',url:'http://esars.crc.losrios.edu/eSARS/CollegeCenter_FA/eSARS.asp?WCI=Init&WCE=Settings',Type:'On-Ground'},
                    {Department:'Admissions and Records',Service:'Student Access Card',Link:'Make an appointment for your Student Access Card',url:'http://esars.crc.losrios.edu/eSARS/CollegeCenter_SA/eSARS.asp?WCI=Init&WCE=Settings',Type:'On-Ground'},
                ],
                fields:[
                    {key:'department',sortable:true,label:'Program or Department'},
                    /*{key:'Service',sortable:false},*/
                    {key:'service',sortable:false,tdClass:'linkclass',label:"Service"},
                    {key:'type',sortable:true,label:'On-Campus / Online'}
                ],
                ignored:[
                    "service","url"
                ]
            }
        },
        computed:{
            encodedAuth(){
                let encoded = "Y3JjXHN2Yy1jYWxtczpzMzNteWxAYnM=";
                return "Basic "+encoded;
            }
        }
    }
</script>

<style>
    /*.linkclass a:hover{
        color:darkblue;
        text-decoration: none;
    }*/
</style>